import { action, API, controller } from "api";
import { useAppContext } from "context";
import { no_img } from "assets";
import { ToFormData } from "hooks";
import React, { useEffect, useState } from "react";

const CompanyProfile = ({ light = false }) => {
  const { bizContext } = useAppContext();
  const [values, setValues] = useState();

  useEffect(() => {
    if (bizContext && bizContext?.companyId) {
      API(controller.Company + action.BizContextDetails).post(
        ToFormData({ ...bizContext }),
        (res) => {
          res?.status === 200
            ? setValues({ ...res?.result })
            : console.error(res?.msg);
        },
      );
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bizContext]);

  return (
    <div className="flex gap-2 items-center px-2 min-w-0">
      <img
        src={values?.companyImgUrl || no_img}
        alt="Company Logo"
        className="h-[40px] object-contain flex-shrink-0"
      />
      <div className={`flex flex-col min-w-0 flex-1 ${light ? "text-slate-700" : "text-white"}`}>
        <span className="truncate text-[14px] font-medium leading-tight">{values?.companyLabel}</span>
        <span className={`text-[12px] tracking-wider truncate leading-tight ${light ? "text-slate-400" : ""}`}>
          {values?.outletLabel}
        </span>
      </div>
    </div>
  );
};

export default CompanyProfile;
